import React, { useEffect } from 'react';
import { usePrefs, useFlags } from 'wsm-common-data';
import clickpathGenerator from '../utils/clickpathGenerator';
import clickpathInjector from '../utils/clickpathInjector';

if (typeof window !== 'undefined') {
	import('../utils/eventHandling/handleEvents.js').then((module) => {
		module.default(window);
	});
}

const Widget = () => {
	const { maxClickpathCount } = usePrefs();
	const { 'ws-tracking-clickpath': wsTrackingClickpathEnabled } = useFlags();
	useEffect(() => {
		clickpathGenerator();
		if (wsTrackingClickpathEnabled) {
			clickpathInjector(parseInt(maxClickpathCount, 10));
		}
	});
	return <React.Fragment />;
};

export default Widget;
